(function () {
  function initHomeHero(root) {
      if (!root || root.dataset.ahhcBound === 'true') return;
      root.dataset.ahhcBound = 'true';

      var track = root.querySelector('[data-slide-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide-panel]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-slide-tab]'));
      var prev = root.querySelector('[data-slide-prev]');
      var next = root.querySelector('[data-slide-next]');
      var progress = root.querySelector('[data-progress-bar]');
      var currentCount = root.querySelector('[data-current-count]');
      var viewport = root.querySelector('.ahhc__viewport');
      var launchNudge = root.querySelector('[data-piano-launch-nudge]');
      var launchNudgeClose = launchNudge ? launchNudge.querySelector('[data-piano-launch-nudge-close]') : null;
      var launchNudgeTimer = null;
      var launchNudgeShowTimer = null;
      var launchNudgePollTimer = null;
      var newsletterTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-ahhc-newsletter-open]'));
      var loopOverlay = null;
      var mobileTrackQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
      var resizeObserver = null;
      var active = 0;
      var autoplayDelay = 7000;
      var initialAutoplayDelay = 16000;
      var hasScheduledInitialAutoplay = false;
      var autoplayTimer = null;
      var scrollLockTimer = null;
      var loopCleanupTimer = null;
      var isPaused = false;
      var isLoopAnimating = false;
      var isProgrammaticScroll = false;
      var ticking = false;

      if (!track || !slides.length) return;

      newsletterTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          document.dispatchEvent(new CustomEvent('reminder:openNewsletter', { bubbles: true }));
        });
      });

      function storageAvailable() {
        try {
          return 'sessionStorage' in window && window.sessionStorage;
        } catch (error) {
          return null;
        }
      }

      function hideLaunchNudge(persist) {
        if (!launchNudge) return;

        if (launchNudgeShowTimer) {
          window.clearTimeout(launchNudgeShowTimer);
          launchNudgeShowTimer = null;
        }

        if (launchNudgePollTimer) {
          window.clearTimeout(launchNudgePollTimer);
          launchNudgePollTimer = null;
        }

        if (launchNudgeTimer) {
          window.clearTimeout(launchNudgeTimer);
          launchNudgeTimer = null;
        }

        launchNudge.classList.remove('is-visible');
        launchNudge.classList.add('is-hiding');

        if (persist) {
          var storage = storageAvailable();
          if (storage) {
            storage.setItem('abrsm-digital-sheet-music-nudge-202607', 'hidden');
          }
        }

        window.setTimeout(function () {
          launchNudge.hidden = true;
        }, 430);
      }

      function cookieConsentVisible() {
        var cookieBanner = document.getElementById('shopify-pc__banner');
        if (!cookieBanner) return false;

        var style = window.getComputedStyle(cookieBanner);
        var rect = cookieBanner.getBoundingClientRect();

        return style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0' &&
          rect.width > 0 &&
          rect.height > 0;
      }

      function isVisibleUiLayer(element) {
        if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

        var style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

        var rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }

      function activeStorefrontUiVisible() {
        if (
          document.body.classList.contains('predictive-overflow-hidden') ||
          document.body.classList.contains('js-drawer-open') ||
          document.documentElement.classList.contains('js-drawer-open') ||
          document.body.classList.contains('modal-open') ||
          document.documentElement.classList.contains('modal-open')
        ) {
          return true;
        }

        var activeLayerSelectors = [
          'predictive-search.is-active',
          '.hdr-suggest.is-active',
          '.abrsm-msearch[aria-hidden="false"]',
          '.drawer.is-active',
          '.drawer.drawer--is-open',
          '.modal.modal--is-active',
          '.abrsm-pdp-format-modal.is-active',
          '[data-abrsm-utility-dock][data-menu-open="true"]',
          '[aria-modal="true"]:not([aria-hidden="true"])'
        ];

        for (var index = 0; index < activeLayerSelectors.length; index += 1) {
          var layer = document.querySelector(activeLayerSelectors[index]);
          if (isVisibleUiLayer(layer)) {
            return true;
          }
        }

        return false;
      }

      function shouldDeferLaunchNudge() {
        return cookieConsentVisible() || activeStorefrontUiVisible();
      }

      function showLaunchNudge() {
        if (!launchNudge || launchNudge.classList.contains('is-visible')) return;

        if (shouldDeferLaunchNudge()) {
          queueLaunchNudge();
          return;
        }

        launchNudge.hidden = false;
        launchNudge.classList.remove('is-hiding');

        window.setTimeout(function () {
          launchNudge.classList.add('is-visible');
        }, 60);

        launchNudgeTimer = window.setTimeout(function () {
          hideLaunchNudge(true);
        }, 7900);
      }

      function queueLaunchNudge() {
        if (!launchNudge) return;

        if (launchNudgePollTimer) {
          window.clearTimeout(launchNudgePollTimer);
          launchNudgePollTimer = null;
        }

        if (launchNudgeShowTimer) {
          window.clearTimeout(launchNudgeShowTimer);
          launchNudgeShowTimer = null;
        }

        if (shouldDeferLaunchNudge()) {
          launchNudgePollTimer = window.setTimeout(queueLaunchNudge, 600);
          return;
        }

        launchNudgeShowTimer = window.setTimeout(function () {
          launchNudgeShowTimer = null;
          showLaunchNudge();
        }, 12000);
      }

      function initLaunchNudge() {
        if (!launchNudge) return;

        var storage = storageAvailable();
        if (storage && storage.getItem('abrsm-digital-sheet-music-nudge-202607') === 'hidden') {
          return;
        }

        if (launchNudgeClose) {
          launchNudgeClose.addEventListener('click', function () {
            hideLaunchNudge(true);
          });
        }

        [
          'predictive-search:open',
          'abrsm-mobile-search:open',
          'cart:open',
          'theme:cart:open',
          'drawerOpen',
          'modalOpen'
        ].forEach(function (eventName) {
          document.addEventListener(eventName, function () {
            hideLaunchNudge(false);
          });
        });

        [
          'predictive-search:close',
          'predictive-search:close-all',
          'abrsm-mobile-search:close',
          'cart:close'
        ].forEach(function (eventName) {
          document.addEventListener(eventName, function () {
            window.setTimeout(queueLaunchNudge, 700);
          });
        });

        document.addEventListener('abrsm-utility-dock:toggle', function (event) {
          if (event.detail && event.detail.open) {
            hideLaunchNudge(false);
            return;
          }

          window.setTimeout(queueLaunchNudge, 700);
        });

        document.addEventListener('abrsm-utility-dock:engage', function () {
          hideLaunchNudge(false);
        });

        document.addEventListener('focusin', function (event) {
          var target = event.target;
          if (target && target.closest && target.closest('input[type="search"], .hdr-search, .abrsm-msearch, .site-header__search-container')) {
            hideLaunchNudge(false);
          }
        }, true);

        queueLaunchNudge();
      }

      function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function shouldAutoplay() {
        return slides.length > 1 && !prefersReducedMotion();
      }

      function normalizeIndex(index) {
        if (!slides.length) return 0;
        if (index < 0) return slides.length - 1;
        if (index >= slides.length) return 0;
        return index;
      }

      function setScrollLock(duration, settleLeft) {
        if (scrollLockTimer) {
          window.clearTimeout(scrollLockTimer);
        }

        isProgrammaticScroll = true;
        scrollLockTimer = window.setTimeout(function () {
          if (Number.isFinite(settleLeft)) {
            setTrackPosition(settleLeft, 'instant');
          }
          isProgrammaticScroll = false;
          scrollLockTimer = null;
        }, duration);
      }

      function clearLoopAnimation() {
        if (loopCleanupTimer) {
          window.clearTimeout(loopCleanupTimer);
          loopCleanupTimer = null;
        }

        if (loopOverlay) {
          loopOverlay.hidden = true;
          loopOverlay.innerHTML = '';
        }

        isLoopAnimating = false;
      }

      function setTrackPosition(left, behavior) {
        if (behavior === 'instant') {
          track.scrollLeft = left;

          if (track.scrollLeft !== left) {
            try {
              track.scrollTo({
                left: left,
                behavior: 'instant'
              });
            } catch (error) {
              track.scrollTo(left, 0);
            }
          }

          if (track.scrollLeft !== left) {
            track.scrollTo(left, 0);
          }

          return;
        }

        track.scrollTo({
          left: left,
          behavior: behavior
        });
      }

      function jumpToLogical(index) {
        if (!slides[index]) return;

        setScrollLock(40);
        setTrackPosition(slides[index].offsetLeft, 'instant');
      }

      function nearestSlide() {
        var left = track.scrollLeft;
        var best = slides[0] || null;
        var delta = Infinity;

        slides.forEach(function (slide) {
          var nextDelta = Math.abs(slide.offsetLeft - left);
          if (nextDelta < delta) {
            delta = nextDelta;
            best = slide;
          }
        });

        return best;
      }

      function ensureLoopOverlay() {
        if (!viewport) return null;

        if (!loopOverlay) {
          loopOverlay = document.createElement('div');
          loopOverlay.className = 'ahhc__loop-overlay';
          loopOverlay.hidden = true;
          viewport.appendChild(loopOverlay);
        }

        return loopOverlay;
      }

      function setTrackHeight() {
        var activeSlide = slides[active];
        var scene = activeSlide ? activeSlide.querySelector('.ahhc__scene') : null;
        var inner = scene ? scene.querySelector('.ahhc__inner') : null;
        var naturalHeight = Math.max(scene ? scene.offsetHeight : 0, inner ? inner.offsetHeight : 0);

        if (!track || !activeSlide) return;

        if (!mobileTrackQuery || !mobileTrackQuery.matches) {
          track.style.height = '';
          return;
        }

        track.style.height = naturalHeight + 'px';
      }

      function observeActiveSlide() {
        if (!('ResizeObserver' in window)) return;

        if (!resizeObserver) {
          resizeObserver = new ResizeObserver(function () {
            window.requestAnimationFrame(setTrackHeight);
          });
        } else {
          resizeObserver.disconnect();
        }

        if (slides[active]) {
          resizeObserver.observe(slides[active]);
        }
      }

      function syncTrackHeight() {
        window.requestAnimationFrame(setTrackHeight);
        observeActiveSlide();
      }

      function stripCloneIds(node) {
        if (!node || node.nodeType !== 1) return;

        if (node.hasAttribute('id')) {
          node.removeAttribute('id');
        }

        Array.prototype.forEach.call(node.children, stripCloneIds);
      }

      function buildLoopClone(index) {
        if (!slides[index]) return null;

        var clone = slides[index].cloneNode(true);
        stripCloneIds(clone);
        clone.classList.add('ahhc__loop-slide', 'is-active');
        clone.removeAttribute('data-slide-panel');
        clone.removeAttribute('data-slide-index');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.removeAttribute('tabindex');

        if ('inert' in clone) {
          clone.inert = true;
        }

        Array.prototype.forEach.call(
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]'),
          function (focusable) {
            focusable.setAttribute('tabindex', '-1');
            focusable.setAttribute('aria-hidden', 'true');
          }
        );

        return clone;
      }

      function animateLoop(previousIndex, nextIndex, shouldResetAutoplay) {
        var overlay = ensureLoopOverlay();
        var outgoing = buildLoopClone(previousIndex);
        var incoming = buildLoopClone(nextIndex);
        var incomingStart = nextIndex === 0 ? '100%' : '-100%';
        var outgoingEnd = nextIndex === 0 ? '-100%' : '100%';

        if (!overlay || !outgoing || !incoming) {
          jumpToLogical(nextIndex);
          if (shouldResetAutoplay) {
            scheduleAutoplay();
          }
          return;
        }

        clearLoopAnimation();
        isLoopAnimating = true;
        overlay.hidden = false;
        outgoing.style.transform = 'translate3d(0, 0, 0)';
        incoming.style.transform = 'translate3d(' + incomingStart + ', 0, 0)';
        overlay.appendChild(outgoing);
        overlay.appendChild(incoming);
        void overlay.offsetWidth;

        setScrollLock(680);
        window.requestAnimationFrame(function () {
          outgoing.style.transform = 'translate3d(' + outgoingEnd + ', 0, 0)';
          incoming.style.transform = 'translate3d(0, 0, 0)';
        });

        loopCleanupTimer = window.setTimeout(function () {
          clearLoopAnimation();
          jumpToLogical(nextIndex);
          if (shouldResetAutoplay) {
            scheduleAutoplay();
          }
        }, 600);
      }

      function clearAutoplay() {
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function scheduleAutoplay() {
        clearAutoplay();

        if (!shouldAutoplay() || isPaused) return;

        var delay = hasScheduledInitialAutoplay ? autoplayDelay : initialAutoplayDelay;
        hasScheduledInitialAutoplay = true;

        autoplayTimer = window.setTimeout(function () {
          sync((active + 1) % slides.length, true, true);
        }, delay);
      }

      function pauseAutoplay() {
        isPaused = true;
        clearAutoplay();
      }

      function resumeAutoplay() {
        isPaused = false;
        scheduleAutoplay();
      }

      function formatIndex(index) {
        return String(index + 1).padStart(2, '0');
      }

      function setProgress() {
        if (progress) {
          progress.style.transform = 'scaleX(' + ((active + 1) / slides.length) + ')';
        }

        if (currentCount) {
          currentCount.textContent = formatIndex(active);
        }

        if (slides[active]) {
          root.setAttribute('data-active-type', slides[active].getAttribute('data-slide-type') || '');
        }
      }

      function keepActiveTabInStrip(shouldScroll) {
        var tab = tabs[active];
        var scroller = tab ? tab.parentElement : null;
        if (!tab || !scroller) return;

        var padding = 12;
        var tabLeft = tab.offsetLeft;
        var tabRight = tabLeft + tab.offsetWidth;
        var visibleLeft = scroller.scrollLeft;
        var visibleRight = visibleLeft + scroller.clientWidth;
        var targetLeft = null;

        if (tabLeft < visibleLeft + padding) {
          targetLeft = Math.max(0, tabLeft - padding);
        } else if (tabRight > visibleRight - padding) {
          targetLeft = tabRight - scroller.clientWidth + padding;
        }

        if (targetLeft === null) return;

        try {
          scroller.scrollTo({
            left: targetLeft,
            behavior: shouldScroll && !prefersReducedMotion() ? 'smooth' : 'auto'
          });
        } catch (error) {
          scroller.scrollLeft = targetLeft;
        }
      }

      function setSlideFocusability(slide, isActive) {
        if (!slide) return;

        if ('inert' in slide) {
          slide.inert = !isActive;
        }

        Array.prototype.forEach.call(
          slide.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'),
          function (focusable) {
            if (isActive) {
              if (focusable.hasAttribute('data-ahhc-tabindex')) {
                var originalTabindex = focusable.getAttribute('data-ahhc-tabindex');
                if (originalTabindex === '') {
                  focusable.removeAttribute('tabindex');
                } else {
                  focusable.setAttribute('tabindex', originalTabindex);
                }
                focusable.removeAttribute('data-ahhc-tabindex');
              }
              return;
            }

            if (!focusable.hasAttribute('data-ahhc-tabindex')) {
              focusable.setAttribute('data-ahhc-tabindex', focusable.getAttribute('tabindex') || '');
            }
            focusable.setAttribute('tabindex', '-1');
          }
        );
      }

      function sync(index, shouldScroll, forceAutoplayReset) {
        var previous = active;
        var nextIndex = normalizeIndex(index);
        var shouldResetAutoplay = forceAutoplayReset || nextIndex !== previous;
        var shouldAnimateLoop =
          shouldScroll &&
          !prefersReducedMotion() &&
          slides.length > 1 &&
          ((previous === slides.length - 1 && nextIndex === 0) ||
            (previous === 0 && nextIndex === slides.length - 1));

        if (isLoopAnimating) {
          clearLoopAnimation();
          jumpToLogical(active);
        }

        active = nextIndex;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === active;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          setSlideFocusability(slide, isActive);
        });

        tabs.forEach(function (tab, tabIndex) {
          var isActive = tabIndex === active;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        keepActiveTabInStrip(shouldScroll);

        if (prev) prev.disabled = slides.length < 2;
        if (next) next.disabled = slides.length < 2;

        setProgress();
        syncTrackHeight();

        if (shouldAnimateLoop && previous !== active) {
          clearAutoplay();
          animateLoop(previous, active, shouldResetAutoplay);
          return;
        }

        if (shouldScroll && slides[active]) {
          var targetLeft = slides[active].offsetLeft;
          clearLoopAnimation();
          setScrollLock(prefersReducedMotion() ? 40 : 620, targetLeft);
          setTrackPosition(targetLeft, prefersReducedMotion() ? 'instant' : 'smooth');
        }

        if (shouldResetAutoplay) {
          scheduleAutoplay();
        }
      }

      track.addEventListener(
        'scroll',
        function () {
          if (isProgrammaticScroll) return;

          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            var nearest = nearestSlide();
            if (nearest) {
              sync(parseInt(nearest.getAttribute('data-slide-index'), 10) || 0, false, false);
            }
            ticking = false;
          });
        },
        { passive: true }
      );

      track.addEventListener('keydown', function (event) {
        if (isLoopAnimating) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          sync(active + 1, true);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          sync(active - 1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          sync(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          sync(slides.length - 1, true);
        }
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (isLoopAnimating) return;
          sync(parseInt(tab.getAttribute('data-slide-index'), 10) || 0, true);
        });

        tab.addEventListener('keydown', function (event) {
          if (isLoopAnimating) return;
          var nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = normalizeIndex(active + 1);
          if (event.key === 'ArrowLeft') nextIndex = normalizeIndex(active - 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = slides.length - 1;

          if (nextIndex !== null) {
            event.preventDefault();
            sync(nextIndex, true);
            if (tabs[nextIndex]) tabs[nextIndex].focus();
          }
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          if (isLoopAnimating) return;
          sync(active - 1, true);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          if (isLoopAnimating) return;
          sync(active + 1, true);
        });
      }

      document.addEventListener('shopify:block:select', function (event) {
        var panel = event.target && event.target.closest ? event.target.closest('[data-slide-panel]') : null;
        if (!panel || !root.contains(panel)) return;
        if (isLoopAnimating) return;
        sync(parseInt(panel.getAttribute('data-slide-index'), 10) || 0, true);
      });

      root.addEventListener('mouseenter', pauseAutoplay);
      root.addEventListener('mouseleave', resumeAutoplay);
      root.addEventListener('focusin', pauseAutoplay);
      root.addEventListener('focusout', function (event) {
        if (root.contains(event.relatedTarget)) return;
        resumeAutoplay();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseAutoplay();
        } else {
          resumeAutoplay();
        }
      });

      window.addEventListener('resize', function () {
        syncTrackHeight();
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          syncTrackHeight();
        });
      }

      jumpToLogical(0);
      sync(0, false, true);
      initLaunchNudge();
  }

  function initHomeHeroes(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    if (scope && scope.matches && scope.matches('[data-abrsm-home-hero-carousel]')) {
      initHomeHero(scope);
    }
    Array.prototype.forEach.call(
      container.querySelectorAll('[data-abrsm-home-hero-carousel]'),
      initHomeHero
    );
  }

  window.__abrsmInitHomeHeroes = initHomeHeroes;
  initHomeHeroes(document);

  if (!window.__abrsmHomeHeroSectionListenerBound) {
    window.__abrsmHomeHeroSectionListenerBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      initHomeHeroes(event.target);
    });
  }
})();
